import { styled } from '@mui/material';
import { ComponentProps } from 'react';
import { Tooltip } from 'ui/components/Tooltip';

const CellWrapper = styled('span')({
  display: 'inline-block',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis'
});

export const CellTooltip = ({ children, ...props }: ComponentProps<typeof Tooltip>) => {
  return (
    <Tooltip {...props}>
      <CellWrapper>{children}</CellWrapper>
    </Tooltip>
  );
};
